import { isAndroidDevice } from '../utils/deviceDetection';
import useIsMobileAppUser from './useIsMobileAppUser';

const useHideChat = (): boolean => useIsMobileAppUser() && !isAndroidDevice();

export default useHideChat;
